import React from 'react';
import './plans.css';

const PLAN_DATA = [
  { duration: 'Monthly', price: 2500, type: 'Gym' },
  { duration: 'Three Months', price: 6000, type: 'Gym' },
  { duration: 'Six Months', price: 10000, type: 'Gym' },
  { duration: 'Annually', price: 16000, type: 'Gym' },
  { duration: 'Monthly', price: 4000, type: 'Pool' },
  { duration: 'Three Months', price: 11000, type: 'Pool' },
  { duration: 'Full Season', price: 21000, type: 'Pool' },
  { duration: 'Monthly', price: 5000, type: 'Gym + Pool' },
  { duration: 'Three Months', price: 14000, type: 'Gym + Pool' },
  { duration: 'Full Season', price: 26000, type: 'Gym + Pool' },
];

function Plans() {
  const handleRowClick = (plan) => {
    console.log(`Plan selected: ${plan.type}, ${plan.duration}, ₹${plan.price}`);
  };

  return (
    <div className="plans-container">
      <h1>Membership Plans</h1>
      <table className="plan-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Duration</th>
            <th>Price</th>
            <th>Price per Month</th>
          </tr>
        </thead>
        <tbody>
          {PLAN_DATA.map((plan, index) => (
            <tr key={index} onClick={() => handleRowClick(plan)}>
              <td>{plan.type}</td>
              <td>{plan.duration}</td>
              <td>₹{plan.price.toFixed(2)}</td>
              <td>₹{(plan.price / (plan.duration === 'Monthly' ? 1 : plan.duration === 'Three Months' ? 3 : plan.duration === 'Six Months' ? 6 : plan.duration === 'Annually' ? 12 : 7)).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Plans;
